var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9785 9.56315V10.0632H13.4785H18.8639H19.8327V20.334C19.8327 20.7208 19.679 21.0917 19.4055 21.3652C19.1321 21.6387 18.7611 21.7923 18.3743 21.7923H6.62435C6.23757 21.7923 5.86664 21.6387 5.59315 21.3652L5.24054 21.7178L5.59315 21.3652C5.31966 21.0917 5.16602 20.7208 5.16602 20.334V4.66732C5.16602 3.85659 5.81362 3.20898 6.62435 3.20898H12.9785V4.17773V9.56315ZM19.8327 8.79109V9.8248L19.2175 9.2096L13.8321 3.82418L13.2169 3.20898H14.2506L19.8327 8.79109ZM15.4368 18.8757H15.9368V18.3757V16.4173V15.9173H15.4368H6.62435H6.12435V16.4173V18.3757V18.8757H6.62435H15.4368ZM18.3743 14.959H18.8743V14.459V12.5007V12.0007H18.3743H6.62435H6.12435V12.5007V14.459V14.959H6.62435H18.3743Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.45009b90.svg";
export { ForwardRef as ReactComponent };